import { render, staticRenderFns } from "./ChooseTheme.vue?vue&type=template&id=36e278cc&"
import script from "./ChooseTheme.vue?vue&type=script&lang=js&"
export * from "./ChooseTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports